export default {"src":"/_next/static/media/0x049d68029688eabf473097a2fc38ef61633a3c7a.fc08aec8.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};